import { Box, InputAdornment, TextField, TextFieldProps, Typography, ValidationErrors, useTheme } from "@compass/core";
import { useState } from "react";
import { displayErrorMessages, getErrorMessages } from "./input-functions";

// dont follow this pattern of props, it's too much duplication
export type InputBaseProps = Omit<TextFieldProps, "helperText"> & {
  // no helperText props because we are using that for validation text
  errors?: ValidationErrors | string[];
  maxLength?: number;
  hideCount?: boolean;
};

export const InputBase = ({
  label,
  value,
  type,
  placeholder,
  size = "medium",
  errors,
  multiline,
  minRows,
  maxLength,
  hideCount,
  inputProps,
  InputProps,
  ...rest
}: InputBaseProps) => {
  const errorMsg = getErrorMessages(errors);
  const hasError = errorMsg?.length > 0 ? true : false;
  const [focused, setFocused] = useState(false);
  const theme = useTheme();

  let _value: string = value as unknown as string;

  if (type === "duration") {
    placeholder = "hh:mm";

    if (_value) {
      const splits: string[] = _value.split(":");
      if (splits.length === 3) _value = `${splits[0]}:${splits[1]}`;
    }
  }

  if ((_value as unknown as number) === 0) {
    _value = "0";
  }

  return (
    <TextField
      fullWidth
      label={label}
      value={_value !== null && _value !== undefined ? _value : ""}
      error={hasError}
      helperText={displayErrorMessages(errorMsg)}
      variant={"outlined"}
      type={type}
      //InputLabelProps={{ shrink: false }}
      multiline={multiline}
      placeholder={placeholder}
      minRows={minRows ? minRows : 2} // only applies if multiline === true
      maxRows={Infinity} // only applies if multiline === true
      size={size}
      autoComplete="off"
      inputProps={{
        ...inputProps,
        maxLength: maxLength,
      }}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {InputProps?.endAdornment}

            {focused === true && !hideCount && type !== "number" && (
              <InputAdornment position="end">
                <Box display="flex" alignItems="flex-start" height="100%">
                  <Typography
                    variant="caption"
                    fontSize="0.6rem"
                    color={
                      focused === true && maxLength !== undefined && maxLength > 0 && _value?.length === maxLength
                        ? theme.palette.warning.main
                        : undefined
                    }
                  >
                    <>{_value?.length ?? 0}</>
                    {maxLength && <>/{maxLength}</>}
                  </Typography>
                </Box>
              </InputAdornment>
            )}
          </>
        ),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      {...rest}
    />
  );
};
